import { Location } from "@angular/common";
import { Component, DestroyRef, inject, OnInit, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { filter } from "rxjs";
import { FooterComponent } from "../components/footer/footer.component";
import { HeaderComponent } from "../components/header/header.component";
import { AuthService } from "../services/auth.service";

@Component({
  selector: "applayout",
  template: `
    <app-header />

    @if (auth.isLoggedIn() && !isHomePage()) {
      <div class="container pt-3  bg-light">
        <button
          class="btn btn-outline-primary rounded-pill mb-3"
          (click)="goBack()"
          title="Go back"
        >
          <i class="bi bi-arrow-left"></i>
          kembali
        </button>
      </div>
    }

    <div class="layout-shell">
      <router-outlet></router-outlet>
    </div>

    @if (isLandingPage()) {
      <app-footer />
    }
  `,
  styles: [
    `
      .layout-shell {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        justify-content: space-between;
        background-color: #edf1f7;
      }
    `,
  ],
  imports: [HeaderComponent, FooterComponent, RouterOutlet],
})
export class MainLayout implements OnInit {
  private location = inject(Location);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  auth = inject(AuthService);
  isLandingPage = signal(false);
  isHomePage = signal(false);

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event: NavigationEnd) => {
        this.checkLandingPage(event.urlAfterRedirects || event.url);
        this.checkHomePage(event.urlAfterRedirects || event.url);
      });

    // Check initial state
    this.checkLandingPage(this.router.url);
    this.checkHomePage(this.router.url);
  }

  private checkLandingPage(url: string) {
    const path = url.split("?")[0].split("#")[0];
    this.isLandingPage.set(path === "/");
  }

  private checkHomePage(url: string) {
    const path = url.split("?")[0].split("#")[0];
    this.isHomePage.set(path === "/home");
  }

  goBack() {
    this.location.back();
  }
}
